import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Nav, NavItem, Button, PageHeader, Popover, Overlay} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import StaticMap from '../../core/components/StaticMap'
import config from '../../config'
import {loadBuilding, loadLotStream} from '../actions'
import i18n from '../i18n'
import ReferenceLotPopover from './ReferenceLotPopover'
import style from './BuildingDetail.less'

class BuildingDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedPopover: null})
    }

    _openNewAuditWindow(event) {
        const {building} = this.props

        event.preventDefault()
        window.open(config.audit.url + '/audits/new?externalRefType=Building&externalRefUid=' + building.uid, '_blank')
    }

    _reload() {
        const {dispatch} = this.props

        return dispatch(loadBuilding()).then(() => {
            return dispatch(loadLotStream())
        })
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {children, dispatch, location, building, buildingLots, auditStats} = this.props
        const {openedPopover} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {buildingLots._links.find(linkFinder('ReferenceLot')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'ReferenceLotPopover')}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.newLot}</span>
                            </a>
                        </li>
                    )}
                    {config.feature.audit && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openNewAuditWindow(e)}>
                                <Icon icon='plus' size='xs' />
                                <span> {i18n.newAudit}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={() => this._closePopover()}>
                {popover}
            </Overlay>
        )

        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader
                        className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <span>{i18n.building} {building.label}</span>
                            {building.addresses[0] && (
                                <span>
                                    <span> : {building.addresses[0].number}</span>
                                    <span> {building.addresses[0].street}</span>
                                    <span>, {building.addresses[0].zipCode}</span>
                                    <span> {building.addresses[0].city}</span>
                                </span>
                            )}
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {buildingLots._links.find(linkFinder('ReferenceLot')) && editOverlay('ReferenceLotPopover', (
                            <ReferenceLotPopover
                                addresses={building.addresses}
                                building={building}
                                onHide={(e) => this._closePopover(e)}
                                onSubmit={() => this._reload()} />
                        ))}
                    </PageHeader>
                    <Row>
                        <Col sm={4}>
                            <div className={style.stats}>
                                <h4>{i18n.currentYearStats}</h4>
                                <div className={style.count}>
                                    <span>---</span>
                                    <small>{i18n.openedTickets}</small>
                                </div>
                                <div className={style.count}>
                                    <span>---</span>
                                    <small>{i18n.nextInterventions}</small>
                                </div>
                                {config.feature.audit && (
                                    <div className={style.count}>
                                        <span>{auditStats.newAudits.currentYear}</span>
                                        <small>{i18n.newAudits}</small>
                                    </div>
                                )}
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className={style.map}>
                                <div>
                                    <div className={style.metric}>
                                        <span>{i18n.lots}</span>
                                        <a
                                            href=''
                                            onClick={(e) => this._navigate(e, '/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid + '/lots')}>
                                            <Icon
                                                icon='lot'
                                                size='sm'
                                                count={buildingLots.count} />
                                        </a>
                                    </div>
                                </div>
                                <StaticMap info
                                    apiKey={config.google.apiKey}
                                    ratio={16/9}
                                    identify={(a) => a.geoLocation}
                                    value={building.addresses} />
                            </div>
                        </Col>
                        <Col sm={4}>
                            <div className={style.events}>
                                <h4>{i18n.nextBuildingEvent}</h4>
                                <div className={style.count}>
                                    <small>---</small>
                                    <span>---</span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem
                            active={location.pathname.match(/\/patrimonies\/[\w-]+\/buildings\/[\w-]+$/) != null}
                            onClick={() => dispatch(push('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid))}>
                            {i18n.synthesis}
                        </NavItem>
                        <NavItem
                            active={location.pathname.match(/\/patrimonies\/[\w-]+\/buildings\/[\w-]+\/lots/) != null}
                            onClick={() => dispatch(push('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid + '/lots'))}>
                            {i18n.lots}
                        </NavItem>
                        <NavItem disabled>{i18n.directory}</NavItem>
                        <NavItem disabled>{i18n.tickets}</NavItem>
                        {config.feature.audit && (
                            <NavItem
                                active={location.pathname.match(/\/patrimonies\/[\w-]+\/buildings\/[\w-]+\/audits/) != null}
                                onClick={() => dispatch(push('/patrimonies/' + building.patrimony.uid + '/buildings/' + building.uid + '/audits'))}>
                                {i18n.audits}
                            </NavItem>
                        )}
                        <NavItem disabled>{i18n.providers}</NavItem>
                        <NavItem disabled>{i18n.documents}</NavItem>
                    </Nav>
                </div>
                {children}
            </div>
        )
    }
}

BuildingDetail = connect((state) => ({
    location: state.router.location,
    building: state.patrimony.building.building,
    buildingLots: state.patrimony.building.buildingLots,
    auditStats: state.audit.report.stats
}))(BuildingDetail)

export default BuildingDetail


// WEBPACK FOOTER //
// ./lib/patrimony/components/BuildingDetail.js